import fetchServer from "../../fetchServer"

export default async function createAirlineCommission(data) {
  let result = {return: 0,msg: 'Something went wrong creating airline commission!'}

  await fetchServer({method: 'POST',url: '/product/v1/airlineCommission',data})
  .then((res) => {
    if(res?.data && !res?.data?.error) {
      result = {return: 1,msg: 'Successfull',data: res?.data?.data}
    } else if(res?.data?.error) result['msg'] = res.data.error
  })
  .catch((err) => {
    console.log('Network Error!')
  })

  return result;
}